import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { clubApi } from "../../club-api-client";
import type { UpsertAssessment } from "../../types";
import { queryKeys } from "../query-keys";

export function useClubAssessments(clubId: string | null) {
	return useQuery({
		enabled: !!clubId,
		queryFn: () => clubApi.training.assessments.list(clubId!),
		queryKey: queryKeys.clubPortal.assessments(clubId ?? ""),
	});
}

export function useMemberAssessment(clubId: string | null, userId: string | null) {
	return useQuery({
		enabled: !!clubId && !!userId,
		queryFn: () => clubApi.training.assessments.get(clubId!, userId!),
		queryKey: queryKeys.clubPortal.assessment(clubId ?? "", userId ?? ""),
	});
}

export function useUpsertAssessment(clubId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({ userId, data }: { userId: string; data: UpsertAssessment }) =>
			clubApi.training.assessments.upsert(clubId, userId, data),
		onSuccess: (_data, { userId }) => {
			qc.invalidateQueries({ queryKey: queryKeys.clubPortal.assessment(clubId, userId) });
			qc.invalidateQueries({ queryKey: queryKeys.clubPortal.assessments(clubId) });
		},
	});
}

export function useDeleteAssessment(clubId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (userId: string) => clubApi.training.assessments.delete(clubId, userId),
		onSuccess: (_data, userId) => {
			qc.invalidateQueries({ queryKey: queryKeys.clubPortal.assessment(clubId, userId) });
			qc.invalidateQueries({ queryKey: queryKeys.clubPortal.assessments(clubId) });
		},
	});
}
